export function formatNumber(value, decimals){
    const formattedValue = Number(value).toFixed(decimals);
    const dotIndex = formattedValue.indexOf('.');
    const decimalValue = formattedValue.substr(dotIndex + 1, formattedValue.length);

    if(decimalValue === '0'.repeat(decimals)){
        return formattedValue.substr(0, dotIndex);
    }

    return formattedValue;
}
